import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { RegisterForm } from "./RegisterForm";

export function googleLoginUrl() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/login";
  return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleCallback({ hash }) {
  const { loginGoogle } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");
  const [reg, setReg] = useState(null);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    loginGoogle(sid).then((r) => { if (r?.registration) setReg(r); else nav("/", { replace: true }); }).catch((e) => setError(errMsg(e)));
  }, [hash, loginGoogle, nav]);
  if (reg) return <RegisterForm reg={reg} />;
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="tl-card max-w-md w-full text-center space-y-4" data-testid="google-callback">
        {!error ? <Loader2 className="animate-spin mx-auto" size={28} /> : (
          <>
            <p className="text-sm text-slate-700" data-testid="google-callback-error">{error}</p>
            <Link to="/login" className="tl-btn tl-btn-primary w-full" data-testid="google-callback-back">Retour à la connexion</Link>
          </>
        )}
      </div>
    </div>
  );
}

export function GoogleButton() {
  return (
    <a href={googleLoginUrl()} className="tl-btn tl-btn-ghost w-full border border-slate-300" data-testid="google-login-button">
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" /></svg>
      Se connecter avec Google
    </a>
  );
}
